/*
|--------------------------------------------------------------------------
| Component: LanguageSwitcherTabs.jsx
| Author: Sayed Ahmed
| Description: Renders language tabs for switching translation input.
|--------------------------------------------------------------------------
*/

import React from "react";

const LanguageSwitcherTabs = ({ languages = [], activeLang, onChange }) => {
  // Do not render if there are no languages provided
  if (!languages.length) return null;

  return (
    <div className="mb-3 d-flex gap-2 flex-wrap">
      {languages.map((lang) => (
        <button
          key={lang.slug}
          type="button"
          onClick={() => onChange(lang.slug)}
          className={`btn btn-sm ${
            activeLang === lang.slug ? "btn-primary" : "btn-outline-primary"
          }`}
        >
          {lang.name}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcherTabs;
